import _ from 'underscore';

import contactType from 'helpers/contact_type';

angular.module('gym.components').directive('memberStyles', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/member_styles.html.slim'),
    scope: {
      contact: '=',
      permissions: '=',
      form: '=',
      addStyle: '&',
      editStyle: '&',
      removeStyle: '&',
      reloadContact: '&'
    },
    controller: ["$rootScope", "$scope", "$http", "MessageService", function($rootScope, $scope, $http, MessageService) {
      var gym;
      gym = $rootScope.gym;
      $scope.$watch('contact.member_styles', function(memberStyles) {
        $scope.styles = memberStyles.filter(function(item) {
          return item.enabled;
        });
        return $scope.deactivatedStyles = memberStyles.filter(function(item) {
          return !item.enabled;
        });
      });
      $scope.toggleList = function() {
        return $scope.displayDeactivated = !$scope.displayDeactivated;
      };
      return $scope.undo = function(memberStyle) {
        var afterThisChange, performed, performedBy, revertablePromotion;
        revertablePromotion = memberStyle.revertable_promotion_details;
        performed = moment(revertablePromotion.graded_on).format('MMM D, YYYY');
        performedBy = revertablePromotion.grading_performed_by ? `by ${_.escape(revertablePromotion.grading_performed_by)}` : '';
        afterThisChange = revertablePromotion.previous_rank_name ? `After this change, the contact's new rank will be <strong>${_.escape(revertablePromotion.previous_rank_name)}</strong>.` : "After this change, the contact will not be ranked for this style.";
        return MessageService.message({
          title: `Remove last grading for ${_.escape(memberStyle.style.name)}`,
          message: [`This will remove ${$scope.contact.name}'s most recent <strong>${_.escape(memberStyle.style.name)}</strong> promotion:`, `<strong>Promoted</strong>: from ${_.escape(revertablePromotion.previous_rank_name) || '(no rank)'} to ${_.escape(memberStyle.current_rank.name)}<br><strong>Performed</strong>: ${performed} ${performedBy}`, afterThisChange],
          bindHtml: true,
          confirmButtonText: 'Undo promotion',
          displayCancelButton: true
        }).then(function() {
          var contact, memberRankId, url;
          contact = $scope.contact;
          memberRankId = memberStyle.revertable_promotion_details.member_rank_id;
          url = `/gyms/${gym.id}/${contactType(contact.type)}/${contact.id}/member_styles/${memberStyle.id}/undo_last_grading`;
          return $http.put(url, {
            member_rank_id: memberRankId
          }).then(function() {
            return $scope.reloadContact();
          });
        });
      };
    }]
  };
});
